module.exports = __webpack_public_path__ + "img/upside_down_face.11577de1.gif";